import {createEvent, createStore} from "effector";
import {persist} from "effector-storage/local";
import {useUnit} from "effector-react/compat";


export const setToken = createEvent<string|null>()

export const $authToken = createStore<string|null>(null)
    .on(setToken, (_, payload)=> payload)

persist({store: $authToken, key: 'authToken'})
export const useAuth = () => {
    const [token] = useUnit([$authToken])
    return {isAuth: !!token}
}

export const setUserId = createEvent<string|null>()

export const $userId = createStore<string|null>(null)
    .on(setUserId, (_, payload)=> payload)

persist({store: $userId, key: 'userId'})

export const useUserId = () => {
    const [userId] = useUnit([$userId])
    return {isAuth: !!userId}
}